import * as React from 'react';

import { useAuthFunctions } from '../../../library/pld-auth'
import { ChatWidget, ChatController } from '../../../library/PLD-Chat-Widget'
import { GridWrapper, GridButton, GridTileItem, DisplayCard } from '../../../library/pld-ui';

export default function NewWidgetTester(props) {
    const auth = useAuthFunctions()
    var chatControllerBubble = ChatController()
    var chatControllerStatic = ChatController({ format: "static"})

    React.useEffect(() => {
        auth.getUser().then((result) => {
            // console.log("gotten_user: ", result)
        })
        // eslint-disable-next-line
    }, [])
    return (
        <>
            <GridWrapper >
                <GridButton text="Toggle Chat Window" onClick={() => chatControllerBubble.ToggleChatWindow()} />
                <GridButton text="Hide Header" onClick={() => chatControllerBubble.hideHeader()} />
                <GridButton text="Show Header" onClick={() => chatControllerBubble.showHeader()} />
                <GridButton text="Close Chat Window" onClick={() => chatControllerBubble.CloseChatWindow()} />
                <GridButton text="Open Chat Window" onClick={() => chatControllerBubble.OpenChatWindow()} />
                <GridButton text="Log Controller" onClick={() => chatControllerBubble.LogController()} />
                <GridButton text="Close Buttons" onClick={() => chatControllerBubble.setConfigValue("displayButtonInput",false)} />
                <GridButton text="Open Buttons" onClick={() => chatControllerBubble.setConfigValue("displayButtonInput",true)} />
                <GridButton text="Placeholder" onClick={() => chatControllerBubble.showHeader()} />
                <GridTileItem>
                    <ChatWidget chatController={chatControllerStatic} />
            </GridTileItem>
            </GridWrapper>
            <ChatWidget chatController={chatControllerBubble} />
        </>
    );
}

